import { createStringEnum, EnumValues } from '@lib/shared-interface-utility-types';

export const SURVEY_QUESTION_FORMATS = ['SINGLE_SELECT', 'MULTIPLE_SELECT'] as const;

/**
 * This is used to differentiate between multiple types of questions and how to display them.
 */
export const SurveyQuestionFormat = createStringEnum(SURVEY_QUESTION_FORMATS);
export type SurveyQuestionFormat = EnumValues<typeof SurveyQuestionFormat>;
